import { PropsWithChildren, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router';

import { ReturnTo } from '@/helpers/redirectTo';
import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { ERoutes } from '@/types/routes';

export const PrivateRoute = ({ children }: PropsWithChildren): ReactElement | null => {
  const { isAuthenticated } = useNewAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const redirectTo = location.pathname + location.search + location.hash;
    if (redirectTo !== '/') {
      ReturnTo.set(redirectTo);
    }

    return <Navigate to={ERoutes.LOGIN} replace />;
  }

  return <>{children}</>;
};
